module.exports = __webpack_public_path__ + "dash_20_app_assets/img/taco.35c0c746.png";